var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 410 410",
    style: {
      enableBackground: "new 0 0 410 410"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1256_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1257_",
    style: {
      fill: "#D80027"
    },
    points: "345.01,207.769 345.01,207.77 250,297.5 385,410 385,170  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1258_",
    style: {
      fill: "#FF5023"
    },
    points: "25,170 25,410 160,297.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1259_",
    style: {
      fill: "#D80027"
    },
    points: "160,297.5 25,410 205,410 205,340  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1260_",
    style: {
      fill: "#A2001D"
    },
    points: "205,340 205,410 385,410 250,297.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1261_",
    style: {
      fill: "#FF5023"
    },
    points: "64.993,132.229 25,170 64.99,170  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1262_",
    style: {
      fill: "#FF5023"
    },
    points: "385,170 345.005,132.227 345.008,170  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1263_",
    style: {
      fill: "#FF5023"
    },
    points: "205,0 141.213,60.243 268.626,60.092  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1264_",
    style: {
      fill: "#A2001D"
    },
    points: "345.01,207.769 385,170 345.008,170  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1265_",
    style: {
      fill: "#A2001D"
    },
    points: "205,340 64.986,207.765 64.99,170 25,170 160,297.5  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1266_",
    style: {
      fill: "#DEDDE0"
    },
    d: "M64.986,207.765L205,340l45-42.5l95.01-89.73v-0.001L345.008,170l-0.003-37.773 L345,60l-76.374,0.092l-127.413,0.151L65,60.334l-0.007,71.895L64.99,170L64.986,207.765z M115,180h180v30H115V180z M115,150v-30 h180v30H115z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1270_",
    x: 115,
    y: 120,
    style: {
      fill: "#FFFFFF"
    },
    width: 180,
    height: 30
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1271_",
    x: 115,
    y: 180,
    style: {
      fill: "#FFFFFF"
    },
    width: 180,
    height: 30
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.28108a264de23d46d1ac0b7c543978a2.svg";
export { ForwardRef as ReactComponent };